import { get, post } from './index';

const localMode = process.env.REACT_APP_LOCAL_MODE === 'true';

const enrich = records => {
  records.forEach(record => {
    record.employee.fullName = `${record.employee.firstName} ${record.employee.lastName}`;
  });
  return records;
}

export const getPto = async () => {
  let ptoRecords = [];

  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(enrich(require('./mock-data/pto.json')));
      }, 500);
    });
  } else {
    ptoRecords = await get(`/pto`);
  }

  return enrich(ptoRecords);
};

export const getPtoAccrualSchedule = async (email) => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(require('./mock-data/ptoAccrualSchedule.json'));
      }, 500);
    });
  } else {
    const res = await post(`/pto_accrual_schedule`, { email });
    return await res.json();
  }
};


export const syncPto = async () => {
  if (localMode) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 500);
    });
  } else {
    return await post('/pto_sync');
  }
};